<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <div>
        <i class="pi pi-file-excel title-card-icon"></i>
      </div>
      <div>
        <p class="mb-0 text-3xl title">{{'menu.importCsv' | transloco}}</p>
        <p>{{'menu.descriptions.importCsv' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="grid">
      <div class="flex flex-column col-12">
        <div class="card">
          <div class="card-header pt-1">
            <h4 class="mb-1">{{'common.information' | transloco}}</h4>
            <button type="button" pButton pRipple (click)="this.infoExpanded = !this.infoExpanded"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="infoExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="color: var(--custom-gray)">
            </button>
          </div>
          <ng-container *ngIf="infoExpanded">
            <hr>
            <div class="flex">
              <ul>
                <li class="line-height-3">{{'uploadCsv.format' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.fieldsInfo' | transloco}}</li>
                <div class="my-2">
                  <i class="font-medium">{{'uploadCsv.fields' | transloco}}</i>
                </div>
                <li class="line-height-3">{{'uploadCsv.serial' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.optional' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.simNumber' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.coordinates' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.eui' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.automaticGeoloc' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.subscriptionStatus' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.subscription' | transloco}}</li>
                <li class="line-height-3">{{'uploadCsv.dates' | transloco}}</li>
              </ul>
            </div>
          </ng-container>
        </div>

        <div class="grid mb-2">
          <div [ngClass]="files.length > 0 ? 'col-3': 'col-12'">
            <div class="card h-20rem p-0">
              <app-upload-csv
                [fileExtensions]="['csv']"
                (onFileDropped)="this.processFiles($event)"
                [disabled]="!this.loadedData || this.machinesCreated"
              ></app-upload-csv>
            </div>
          </div>
          <div *ngIf="files.length > 0" class="col-9">
            <div class="card overflow-auto" [ngStyle]="{'max-height': '20rem'}">
              <p-accordion>
                <p-accordionTab *ngFor="let fileData of files; index as fileIndex"
                  [disabled]="fileData.fileErrors == null">
                  <p-header class="w-full">
                    <div class="flex align-items-center justify-content-between w-full ml-2">
                      <div class="w-3rem">
                        <i *ngIf="fileData.fileErrors != null" class="pi pi-file"
                          style="font-size: 2rem; color: var(--custom-red)"></i>
                        <i *ngIf="fileData.fileErrors == null" class="pi pi-file"
                          style="font-size: 2rem; color: var(--custom-green)"></i>
                      </div>
                      <div class="w-full flex">
                        <p class="mb-0 line-height-4">{{ fileData.file.name }}</p>
                        <p class="p-12 ml-4 mb-0 line-height-4 font-normal">
                          {{fileData.file.size / 1024 | number:'1.2-2'}} {{'attribute.kb' | transloco}}
                        </p>
                      </div>
                      <div class="w-3rem flex flex-column md:flex-row justify-content-end">
                        <button (click)="deleteAttachment(fileIndex)" [disabled]="this.machinesCreated" pButton pRipple
                          class="p-button-rounded btn-danger-light pointer-events-auto"
                          style="cursor: pointer !important;" icon="pi pi-trash">
                        </button>
                      </div>
                    </div>
                  </p-header>
                  <p-content>
                    <div>
                      <div class="my-3">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2"
                            style="font-size: 1.5rem; color: var(--custom-red)"></i>
                          <div>
                            {{'error.summary.wrongFileFormat' | transloco}} </div>
                        </h5>
                        <ul>
                          <li *ngFor="let lineError of fileData.fileErrors?.lines">
                            {{ 'error.csvImport.cannotImportMachineOfLine' | transloco: { line: lineError + 1 } }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </p-content>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>

        <div *ngIf="filesUploaded" class="card flex flex-column">
          <div class="card-header pt-1">
            <div class="flex w-full align-items-center justify-content-between">
              <div class="inline mb-1">
                <h4 class="mt-1 inline">{{'uploadCsv.machines' | transloco}}</h4>
              </div>
            </div>
          </div>
          <hr>
          <div class="p-datatable p-component p-datatable-hoverable-rows">
            <p-table [(first)]="first" [(rows)]="rows" [paginator]="true" [responsive]="true" responsiveLayout="stack"
              breakpoint="1700px" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalMachines" [value]="machines"
              styleClass="p-datatable-striped" dataKey="machineIdentifier">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col">{{'attribute.serialNumber' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.alias' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.description' | transloco}}</th>
                  <th scope="col">{{'attribute.simNumber' | transloco}}</th>
                  <th scope="col">{{'attribute.latitude' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.longitude' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.eui' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.model' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.organization' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.automaticGeolocCsv' | transloco}} (*)</th>
                  <th scope="col">{{'attribute.subscription' | transloco}}</th>
                  <th scope="col">{{'attribute.subscriptionStart' | transloco}}</th>
                  <th scope="col">{{'attribute.subscriptionEnd' | transloco}}</th>
                  <th scope="col" class="w-4rem">{{'attribute.state' | transloco}}</th>
                  <th scope="col" class="w-2rem"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-csvMachineData let-expanded="expanded">
                <tr>
                  <td>
                    <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.serial">{{csvMachineData.machine?.serial}}</span>
                    <span *ngIf="!csvMachineData.machine?.serial"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.alias">{{csvMachineData.machine?.alias}}</span>
                    <span *ngIf="!csvMachineData.machine?.alias"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                    <div class="flex justify-content-between">
                      <div *ngIf="csvMachineData.machine?.description != null && csvMachineData.machine?.description.trim() != ''"
                           class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                           pTooltip="{{csvMachineData.machine?.description}}" tooltipPosition="top" [ngStyle]="{'max-width': '6rem'}">
                        {{csvMachineData.machine?.description}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.simNumber' | transloco}}</span>
                    <div *ngIf="csvMachineData.machine?.simNumber != null && csvMachineData.machine?.simNumber.trim() != ''"
                         class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                         pTooltip="{{csvMachineData.machine?.simNumber}}" tooltipPosition="top" [ngStyle]="{'max-width': '8rem'}">
                      {{csvMachineData.machine?.simNumber}}
                    </div>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.latitude' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.latitude">{{csvMachineData.machine?.latitude}}</span>
                    <span *ngIf="!csvMachineData.machine?.latitude"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.longitude' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.longitude">{{csvMachineData.machine?.longitude}}</span>
                    <span *ngIf="!csvMachineData.machine?.longitude"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.eui' | transloco}}</span>
                    <div *ngIf="csvMachineData.machine?.eui" [ngStyle]="{'max-width': '8rem'}"
                          class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                          pTooltip="{{csvMachineData.machine?.eui}}"
                          tooltipPosition="top">
                      {{csvMachineData.machine?.eui}}
                    </div>
                    <span *ngIf="!csvMachineData.machine?.eui"><i
                      style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.model' | transloco}}</span>
                    <span
                      *ngIf="csvMachineData.machineModelName">{{csvMachineData.machineModelName}}</span>
                    <span *ngIf="!csvMachineData.machineModelName"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
                    <div *ngIf="csvMachineData.organization?.name" [ngStyle]="{'max-width': '8rem'}"
                         class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                         pTooltip="{{csvMachineData.organization?.name}}
                         ({{csvMachineData.organization?.orgCode}}, {{csvMachineData.organization?.parentCode}})"
                         tooltipPosition="top">
                      {{csvMachineData.organization?.name}} ({{csvMachineData.organization?.orgCode}}, {{csvMachineData.organization?.parentCode}})
                    </div>
                    <span *ngIf="!csvMachineData.organization?.name"><i
                        style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.automaticGeoloc' | transloco}}</span>
                    <span
                      *ngIf="csvMachineData.machine?.automaticGeoloc">{{csvMachineData.machine?.automaticGeoloc}}</span>
                    <span *ngIf="!csvMachineData.machine?.automaticGeoloc"><i
                      style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i></span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.subscription' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.status">
                      {{csvMachineData.machine?.status}}
                    </span>
                    <span
                      *ngIf="!csvMachineData.machine?.status && (csvMachineData.machine?.startDate || csvMachineData.machine?.endDate)">
                      <i style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.subscriptionStart' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.startDate && isValidDate(csvMachineData.machine?.startDate)">
                      {{csvMachineData.machine?.startDate| date}}
                    </span>
                    <span *ngIf="csvMachineData.machine?.startDate && !isValidDate(csvMachineData.machine?.startDate)">
                      {{csvMachineData.machine?.startDate}}
                    </span>
                    <span
                      *ngIf="!csvMachineData.machine?.startDate && csvMachineData.machine?.status === 'ACTIVE'">
                      <i style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.subscriptionEnd' | transloco}}</span>
                    <span *ngIf="csvMachineData.machine?.endDate && isValidDate(csvMachineData.machine?.endDate)">
                      {{csvMachineData.machine?.endDate| date}}
                    </span>
                    <span *ngIf="csvMachineData.machine?.endDate && !isValidDate(csvMachineData.machine?.endDate)">
                      {{csvMachineData.machine?.endDate}}
                    </span>
                    <span
                      *ngIf="!csvMachineData.machine?.endDate && csvMachineData.machine?.stats === 'ACTIVE'">
                      <i style="color: var(--custom-red)">{{'uploadCsv.noValue' | transloco}}</i>
                    </span>
                  </td>
                  <td>
                    <span class="p-column-title bold">{{'attribute.state' | transloco}}</span>
                    <div class="flex justify-content-center">
                      <div class="pr-4" *ngIf="csvMachineData.status === 'UPLOADED'">
                        <i class="pi pi-check-circle align-self-center"
                          style="font-size: 1.5rem; color: var(--custom-green)"></i>
                      </div>

                      <div class="flex" *ngIf="csvMachineData.status === 'ERROR'">
                        <button type="button" pButton pRipple [pRowToggler]="csvMachineData"
                          class="p-button-text p-button-rounded p-button-plain">
                          <i class="pi pi-times-circle align-self-center"
                            style="font-size: 1.5rem; color: var(--custom-red)"></i>
                          <i class="align-self-center ml-2 line-height-3"
                            [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            style="font-size: 0.7rem; color: var(--custom-gray)"></i>
                        </button>
                      </div>

                      <div class="pr-4" *ngIf="csvMachineData.status === 'UPLOADING'">
                        <i class="pi pi-spin pi-spinner align-self-center"
                          style="font-size: 1.5rem; color: var(--custom-gray)"></i>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="flex justify-content-end">
                      <button (click)="deleteMachine(csvMachineData.machineIdentifier)" pButton pRipple
                        class="p-button-rounded btn-danger-light" icon="pi pi-trash" [disabled]="this.machinesCreated">
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="rowexpansion" let-csvMachineData>
                <tr>
                  <td colspan="15">
                    <div class="overflow-auto" [ngStyle]="{'max-height': '15rem'}">
                      <div class="my-3" *ngFor="let propertyErrors of csvMachineData.errors | keyvalue">
                        <h5 class="flex">
                          <i class="pi pi-times-circle align-self-center mr-2"
                            style="font-size: 1.5rem; color: var(--custom-red)"></i>
                          <div>
                            {{this.machinePropertiesErrors.getTranslation(propertyErrors.key)}} </div>
                        </h5>
                        <ul>
                          <li *ngFor="let error of propertyErrors.value">
                            {{ 'error.csvImport.' + error.message | transloco: error.params }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="machines.length == 0">
                  {{'pagination.empty'| transloco}}</div>
                <div class="flex align-items-center justify-content-between" *ngIf="totalMachines > 0">
                  {{'pagination.showing' | transloco}} {{first + 1}}
                  {{'pagination.to' | transloco}} {{(first + rows) >= totalMachines ? totalMachines : (first + rows)}}
                  {{'pagination.of' | transloco}} {{totalMachines}}
                  {{(totalMachines > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
              </ng-template>
            </p-table>
          </div>
          <div class="grid">
            <div class="col-12">
              <div class="mt-auto col-12">
                <div class="flex justify-content-between mt-4">
                  <button [label]="'common.cancel' | transloco" (click)="cancel()" pButton class="p-button-danger"
                    iconPos="right"></button>
                  <p-button [label]="'common.import' | transloco"
                    [disabled]="this.machines?.length === 0 || machinesCreated" [loading]="creatingMachines"
                    (onClick)="importMachines()" styleClass="p-button-primary"></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
